// Ön Muhasebe Yönetici Ekranı kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'finance.adminDashboard';

export const adminDashboardGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Yönetici Ekranı nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Bu ekran satışlarınızı, kasa ve banka bakiyelerinizi ve en çok satan ürünleri tek bakışta özetler. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık ve Yenile'),
    stats: t(`${G}.regions.stats`, 'Özet kartları'),
    filters: t(`${G}.regions.filters`, 'Şube ve tarih'),
    toolbar: t(`${G}.regions.toolbar`, 'Ayarlar (çark)'),
    table: t(`${G}.regions.table`, 'Widget, grafik ve rapor kartları'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Ekran ne gösterir?'),
      text: t(`${G}.s1.text`, 'Üstte seçtiğiniz şube ve tarih aralığına göre satış toplamı, kasa / banka bakiyeleri, şube satışları, en çok satan ürünler ve grafikler görünür. Verileri tazelemek için başlığın yanındaki "Yenile" düğmesine basın; telefon ve tablette sayfayı aşağı çekerek de yenileyebilirsiniz.'),
    },
    {
      region: 'filters',
      title: t(`${G}.s2.title`, '2. Şube ve tarih aralığını seçin'),
      text: t(`${G}.s2.text`, 'Şube Filtresi boşken (Tümü) bütün şubeler hesaplanır. Tarih düğmeleri: Günlük = bugün, Dün = yalnız dün, Haftalık = son 7 gün ve bugün, Aylık = son 30 gün ve bugün, Yıllık = son 365 gün ve bugün. "Tarih Aralığı" ile saat dahil özel bir başlangıç ve bitiş seçebilirsiniz.'),
      tips: [
        t(`${G}.s2.tip1`, 'Özel aralıkta bitiş, başlangıçtan sonra olmalıdır. Aralık aktifken düğmeye yeniden basmak özel aralığı kaldırır ve Günlük\'e döner.'),
        t(`${G}.s2.tip2`, 'Şube yöneticisi olarak girdiyseniz şube alanı "Şubeniz (Kilitli)" olarak sabittir.'),
      ],
    },
    {
      region: 'stats',
      title: t(`${G}.s3.title`, '3. Özet kartlarındaki sayılar nasıl hesaplanır?'),
      text: t(`${G}.s3.text`, 'Toplam Satış kartı seçilen tarih ve şubedeki satış fişlerinin (hızlı satış, paket, kiosk, QR ve platform siparişleri, ÖKC\'siz nakit dahil) ve tamamlanan restoran adisyonlarının toplamıdır; Gün Sonu raporuyla aynı kaynaktan gelir. Ödenmemiş veya iptal edilen adisyonlar sayılmaz.'),
      tips: [
        t(`${G}.s3.tip1`, 'Toplam Kasa Bakiyesi: seçili şubedeki aktif kasaların bugünkü bakiyelerinin toplamı. Tarih filtresinden etkilenmez.'),
        t(`${G}.s3.tip2`, 'Toplam Banka Bakiyesi: seçili şubedeki aktif banka hesaplarının ve alt hesaplarının bugünkü bakiyelerinin toplamı. Tarih filtresinden etkilenmez.'),
        t(`${G}.s3.tip3`, 'Kasa ve banka kartlarında döviz hesaplarının bakiyeleri kura çevrilmeden toplanır; döviz hesabınız varsa ayrıntıyı Kasalar ve Banka Hesapları listelerinden okuyun.'),
        t(`${G}.s3.tip4`, 'Toplam Stok Ürünü: aktif stok kartı sayısıdır; şube ve tarih seçiminden etkilenmez.'),
        t(`${G}.s3.tip5`, 'Ekran bazlı kartlar (Görünüm Ayarları\'ndan açılır) şube filtresi yerine seçtiğiniz satış / restoran / paket ekranlarının seçili tarihteki satışını gösterir; kart üzerindeki ayar simgesinden ekran seçilir.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Widget\'lar ve grafikler'),
      text: t(`${G}.s4.text`, 'Şube Satışları listesi her şubenin seçili aralıktaki satış tutarını ve satış hareketi sayısını verir; bir satıra tıklayınca o şubede satılan ürünler (miktar, ortalama birim fiyat, toplam, son satış) açılır. En Çok Satan Ürünler stok hareketlerinden, seçili tarih ve şubeye göre hesaplanır; "Detay" tüm listeyi açar. Kasalar ve Banka Hesapları güncel bakiyeleri listeler; grafikler aynı verilerin görsel halidir.'),
      tips: [
        t(`${G}.s4.tip1`, 'Şube Satışları\'ndaki "Tümü" düğmesi, şube filtresinden bağımsız olarak şirketteki her şubeyi listeler; dönemde satışı olmayan şube 0 ile görünür. Şube yöneticisi bu düğmeyi görmez.'),
        t(`${G}.s4.tip2`, 'Şubesi olmayan satışlar "Tüm Şubeler (Genel)" satırında toplanır.'),
      ],
    },
    {
      region: 'toolbar',
      title: t(`${G}.s5.title`, '5. Ekranı kendinize göre düzenleyin'),
      text: t(`${G}.s5.text`, 'Sağdaki çark (Dashboard Ayarları) iki seçenek sunar. "Dashboard Düzeni" ile kartları sürükleyip taşıyabilir, sağ alt köşesinden boyutlandırabilirsiniz; sonra Kaydet, İptal veya Varsayılana Dön\'e basın (yalnız geniş ekranda). "Görünüm Ayarları" ile hangi kartların görüneceğini seçer, özel rapor kartı ekler, düzenler veya silersiniz.'),
      tips: [
        t(`${G}.s5.tip1`, 'Kart düzeni, gizlenen kartlar ve özel rapor kartları bu cihazda (tarayıcıda) saklanır; başka bir bilgisayarda varsayılan düzen görünür.'),
        t(`${G}.s5.tip2`, '"Yeni Rapor Kartı" rapor sihirbazını açar; açıksa "AI ile Rapor İste" ile ne görmek istediğinizi yazarak kart önerisi alabilirsiniz.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s6.title`, '6. Özel rapor kartları'),
      text: t(`${G}.s6.text`, 'Oluşturduğunuz rapor kartları ekrandaki tarih seçimini kullanır; üstteki Şube Filtresi bu kartlara uygulanmaz, şube ayrımını kartın kendi filtresiyle yaparsınız. Tek değer (KPI) kartları, aynı uzunluktaki önceki döneme göre değişimi de gösterir.'),
      tips: [
        t(`${G}.s6.tip1`, 'Kartın üzerindeki kalem simgesi düzenler, çöp kutusu kartı onay sormadan kaldırır; tablo kartlarında "CSV indir" vardır.'),
      ],
    },
  ],
});
